import Tooltip from 'core/components/dialogs/Tooltip'
import Icon from 'core/components/icons/Icon'
import { HexColor, ReportShort } from 'types/entity'

interface Props {
  bgColor: HexColor
  textColor: HexColor
  status: ReportShort['status'] | string
  helpText?: string
}

const Status = ({ textColor, bgColor, status, helpText }: Props) => {
  return (
    <div className="flex justify-center items-center gap-2">
      <span
        style={{
          color: `#${textColor}`,
          backgroundColor: `#${bgColor}`,
          border: `1px solid ${bgColor}`
        }}
        className="rounded-3xl text-center font-semibold leading-[1.6] uppercase px-3 py-[2px] text-[12px] truncate overflow-hidden whitespace-nowrap"
        role="status"
      >
        {status?.replaceAll('_', ' ')}
      </span>
      {helpText && (
        <Tooltip dark position="bottom-middle" content={helpText}>
          <Icon
            name="question"
            size={10}
            className="border border-dark-4 text-dark-4 rounded-full bg-white p-1"
          />
        </Tooltip>
      )}
    </div>
  )
}

export default Status
